import { TableRow, Typography } from '@mui/material';
import { DATE_FORMAT_RANGE_FNS } from '@schooly/api';
import { GridCell } from '@schooly/style';
import { newDateTimezoneOffset } from '@schooly/utils/date';
import { format } from 'date-fns';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export const AttendanceJustificationsTableHeader: FC<{ date: string }> = ({ date }) => {
  const { formatMessage } = useIntl();

  return (
    <TableRow>
      <GridCell borderBottom py={0.75}>
        <Typography variant="h4" color="common.grey">
          {format(newDateTimezoneOffset(date), DATE_FORMAT_RANGE_FNS)}
        </Typography>
      </GridCell>
      <GridCell borderBottom py={0.75} width={110}>
        <Typography color="common.grey">{formatMessage({ id: 'groups-TutorGroups' })}</Typography>
      </GridCell>
      <GridCell borderBottom py={0.75} width={110}>
        <Typography color="common.grey">{formatMessage({ id: 'userType-staff' })}</Typography>
      </GridCell>
      <GridCell borderBottom py={0.75} width={110}>
        <Typography color="common.grey">{formatMessage({ id: 'userType-parent' })}</Typography>
      </GridCell>
      <GridCell borderBottom py={0.75} width={60}>
        <Typography color="common.grey">{formatMessage({ id: 'attendance-AmPm' })}</Typography>
      </GridCell>
      <GridCell borderBottom py={0.75} width={200}>
        <Typography color="common.grey">
          {formatMessage({ id: 'attendance-AttendanceCode' })}
        </Typography>
      </GridCell>
      <GridCell borderBottom py={0.75} width={35} />
    </TableRow>
  );
};
